import gql from "graphql-tag";

const GET_BILLING_DETAILS = gql`
  query billingDetails($orgId: String!) {
    getBillingDetails(orgId: $orgId)
  }
`;

export default GET_BILLING_DETAILS;
